export const customDateSortingFn = (rowA, rowB, columnId) => {
  const dateA = rowA.getValue(columnId);
  const dateB = rowB.getValue(columnId);

  // Handle null or undefined values
  if (!dateA && !dateB) return 0;
  if (!dateA) return -1;
  if (!dateB) return 1;

  return dateA - dateB; // Ascending order
};

//TODO update this dict when you add new custom sort fns
export const sortingFnsDict = {
  customDateSortingFn: customDateSortingFn,
};
